import { useFormikContext } from 'formik'
import { IUserGroup } from '../types'

export function useUserGroupFormContext() {
  return useFormikContext<IUserGroup>()
}
